module.exports = __webpack_public_path__ + "img/formato.efeb642d.png";